export const deleteUrlParam = (paramName: string, queryParams: URLSearchParams) => {
    queryParams.delete(paramName);
    window.history.replaceState({}, '', window.location.pathname);
};

export const deleteMultipleUrlParams = (paramNames: string[], queryParams: URLSearchParams) => {
    paramNames.forEach((paramName) => {
        deleteUrlParam(paramName, queryParams);
    });
};

export const normalizePathname = (pathname: string): string => pathname.replace(/\/+$/, '') || '/';

export const isSamePage = (url1: URL, url2: URL): boolean => url1.origin === url2.origin
    && normalizePathname(url1.pathname) === normalizePathname(url2.pathname);
